import { useNavigate, useRouteError } from 'react-router-dom';
import s from './WorkspaceListErrorElement.module.scss';
import { Button } from '@tremor/react';
import { LoaderError } from '@/types/types';
import { useOrganizationStore } from '@/stores/organizationStore';
import { useUserPermissionsStore } from '@/stores/userPermissionsStore';
import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { NAV_ROUTES } from '@/utils/constants';
import { useWorkspaceIdStore } from '@/stores/workspaceIdStore';

export const WorkspaceListErrorElement = () => {
  const error = useRouteError() as LoaderError;
  const navigate = useNavigate();
  console.error(error);
  const errorMessage =
    error?.code === 'permission-denied'
      ? "It seems that You don't have permission to access this workspace. Please contact your employer or check your invitations"
      : error?.toString();

  const handleGoBack = () => {
    useOrganizationStore.getState().reset();
    useUserPermissionsStore.getState().reset();
    useWorkspaceIdStore.getState().resetWorkspaceId();
    navigate(NAV_ROUTES.root);
  };

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <div className={s.container}>
      {errorMessage}
      <Button onClick={handleGoBack}>Go back to workspaces</Button>
    </div>
  );
};
